/*
 * THE PAGE DOES NOT ZOOM (2026-10-15: "Lock the screen scale so players
 * can't zoom the page"). The world has its own zoom — the wheel over it, a
 * pinch on it, the Reset view mark — and the panels have Button size; a
 * page zoom on top of those only blows the screen up past its edges, and
 * on a phone a stray pinch or double tap over a panel left the game half
 * off the glass with no mark to bring it back.
 *
 * Every browser wants telling a different way, so it is told all of them:
 *
 * - the viewport meta (index.html) says maximum-scale=1 and
 *   user-scalable=no, which Chrome on Android keeps to;
 * - `touch-action: pan-x pan-y` on the page (style.css) takes pinch and
 *   double-tap zoom away from every finger while leaving scrolling alone;
 * - Safari on an iPhone ignores both for the sake of accessibility, so its
 *   own gesture events are called off here, and so is any touchmove with
 *   two fingers down that the world's canvas has not already taken;
 * - on a computer, Ctrl (or ⌘) with the wheel, or a trackpad pinch, which
 *   arrives as the same thing, and Ctrl with + - = or 0, are the page
 *   zoom, and are called off too. The world's own wheel zoom is a plain
 *   wheel and still works; the browser's menu can still zoom, since a page
 *   cannot reach it.
 */

/** Whether a key press, with Ctrl or ⌘ held, is the browser's page zoom. */
export function isZoomKey(e: { key: string; ctrlKey: boolean; metaKey: boolean; altKey: boolean }): boolean {
  if (!(e.ctrlKey || e.metaKey) || e.altKey) return false;
  return e.key === "+" || e.key === "-" || e.key === "=" || e.key === "_" || e.key === "0";
}

/** Calls off every page zoom the page can reach; see the note above. */
export function lockPageZoom(win: Window): void {
  const stop = (e: Event) => {
    if (e.cancelable) e.preventDefault();
  };
  // Safari's pinch, which it reports as gestures of its own.
  for (const type of ["gesturestart", "gesturechange", "gestureend"]) {
    win.document.addEventListener(type, stop, { passive: false });
  }
  win.document.addEventListener(
    "touchmove",
    (e) => {
      if (e.touches.length > 1) stop(e);
    },
    { passive: false },
  );
  win.addEventListener(
    "wheel",
    (e) => {
      if (e.ctrlKey) stop(e);
    },
    { passive: false },
  );
  win.addEventListener("keydown", (e) => {
    if (isZoomKey(e)) stop(e);
  });
}
